import React from 'react';
import { cn } from '../lib/utils';

const variants = {
    error: 'border-red-300 bg-red-50 text-red-800',
    success: 'border-green-300 bg-green-50 text-green-800',
    warning: 'border-yellow-300 bg-yellow-50 text-yellow-800',
    info: 'border-[#bce8f1] bg-[#d9edf7] text-[#31708f]',
};

export function Alert({ variant = 'info', children, className }) {
    return (
        <div className={cn('mb-4 rounded-sm border p-3 text-sm', variants[variant], className)}>
            {children}
        </div>
    );
}
